import React, { PointerEvent as ReactPointerEvent } from "react";

import { ComparisonSide } from "../types";

import * as S from "./TimelineSelector.style";

type Props = {
  left: number;
  top: number;
  height: number;
  onPointerDown: (event: ReactPointerEvent<SVGRectElement>) => void;
  side: ComparisonSide;
};

const TimelineSelectorCursor = ({
  left,
  top,
  height,
  onPointerDown,
  side
}: Props) => {
  return (
    <g onPointerDown={onPointerDown}>
      <S.CursorBackground
        side={side}
        width="8"
        height={height}
        x={left}
        y={top}
      />
      <S.CursorMarker
        y1={top + height / 2 - 12}
        y2={top + height / 2 + 12}
        x1={left + 2.5}
        x2={left + 2.5}
      />
      <S.CursorMarker
        y1={top + height / 2 - 12}
        y2={top + height / 2 + 12}
        x1={left + 5.5}
        x2={left + 5.5}
      />
    </g>
  );
};

export default TimelineSelectorCursor;
